import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { isValidEmail } from "../../common/helper";
import { ManagementService } from "../../services/ManagementService";

export default function RequestToForget() {
  let { t } = useTranslation();
  const [email, setEmail] = useState();
  const [error, setError] = useState();
  function onChange({ target }) {
    setEmail(target.value);
  }

  function validateMail({ target }) {
    if (!isValidEmail(target.value)) setError("Invalid EmailAdress.");
    else setError();
  }
  function submit() {
    if (!email) return;
    ManagementService.forgetCandidateByEmail(email).then((data) => {
      toast.success(t("candidate deleted"));
      setEmail();
    });
  }

  return (

    <> <header className="page-header">
    <div className="header-title">
      <div className="title">
        <h1 style={{ marginTop: "10px" }}>{t("Management")}</h1>
      </div>
      <div className="subtitle">{t("Management /forget Candidate by email")}</div>
    </div>
    <div>
      <div className="text-end col-auto"></div>
    </div>
  </header> <div className="col-sm-4">
      <div className="label-wrapper">
        *<label>{t("Candidate email address")}</label>
        {error && <div className="error-msg">{error}</div>}
      </div>
      <div className="input-group">
        <input
          class="form-control"
          type="text"
          onChange={onChange}
          value={email || ""}
          onBlur={validateMail}
          placeholder={t("email@example.com")}
          maxLength={100}
        />{" "}
        <button
          class="btn btn-outline-secondary"
          type="button"
          onClick={submit}
          disabled={!email}
        >
          Forget
        </button>
      </div>
    </div>
    </>
  
  );
}
